import { reportClientError } from './errorReporter';

let registered = false;
let handleWindowError;
let handleUnhandledRejection;

const normalizeRejectionReason = (reason) => {
  if (reason instanceof Error) {
    return reason;
  }

  if (typeof reason === 'string') {
    return new Error(reason);
  }

  return new Error('Unhandled promise rejection');
};

export const registerGlobalErrorHandlers = () => {
  if (registered) {
    return;
  }

  handleWindowError = (event) => {
    const error = event.error instanceof Error
      ? event.error
      : new Error(event.message || 'Window error');

    reportClientError(error, {
      area: 'application',
      severity: 'error',
      source: 'window.error',
    });
  };

  handleUnhandledRejection = (event) => {
    reportClientError(normalizeRejectionReason(event.reason), {
      area: 'application',
      severity: 'error',
      source: 'unhandledrejection',
    });
  };

  window.addEventListener('error', handleWindowError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
  registered = true;
};

export const resetGlobalErrorHandlersForTests = () => {
  if (!registered) {
    return;
  }

  window.removeEventListener('error', handleWindowError);
  window.removeEventListener('unhandledrejection', handleUnhandledRejection);
  registered = false;
  handleWindowError = null;
  handleUnhandledRejection = null;
};
